import React from 'react';
import { AppTooltip } from '@/components/atoms';

export interface InfoRowProps {
  label: string;
  value: React.ReactNode;
  labelWidth?: string;
  classNameLabel?: string;
  classNameValue?: string;
}

/**
 * Single label-value row for detail/read-only displays
 * Shows tooltip only when text is truncated
 */
export const InfoRow: React.FC<InfoRowProps> = ({
  label,
  value,
  classNameLabel,
  classNameValue,
  labelWidth = 'w-1/6',
}) => {
  return (
    <div className="flex items-center py-1">
      <div className={`${labelWidth} ${classNameLabel ?? ''} text-gray-700 font-bold min-h-[32px] flex items-center`}>
        {label}
      </div>
      <div className={`flex-1 pb-1 border-b border-gray-300 min-h-[32px] flex items-center ${classNameValue ?? ''}`}>
        {typeof value === 'string' || typeof value === 'number' ? (
          <AppTooltip title={String(value)} placement="top" showOnlyOnOverflow>
            <span className="block w-full truncate">{value ?? '-'}</span>
          </AppTooltip>
        ) : (
          (value ?? '-')
        )}
      </div>
    </div>
  );
};

export interface TwoColumnInfoRowProps {
  label1: string;
  value1: React.ReactNode;
  label2: string;
  value2: React.ReactNode;
}

/**
 * Two-column label-value row for detail displays
 * Shows tooltip only when text is truncated
 */
export const TwoColumnInfoRow: React.FC<TwoColumnInfoRowProps> = ({
  label1,
  value1,
  label2,
  value2,
}) => {
  return (
    <div className="flex items-center py-1">
      <div className="w-1/6 font-bold text-gray-700 min-h-[32px] flex items-center">{label1}</div>
      <div className="w-1/3 pb-1 mr-4 border-b border-gray-300 min-h-[32px] flex items-center">
        {typeof value1 === 'string' || typeof value1 === 'number' ? (
          <AppTooltip title={String(value1)} placement="top" showOnlyOnOverflow>
            <span className="block w-full truncate">{value1 ?? '-'}</span>
          </AppTooltip>
        ) : (
          (value1 ?? '-')
        )}
      </div>
      <div className="w-1/6 font-bold text-gray-700 min-h-[32px] flex items-center">{label2}</div>
      <div className="w-1/3 pb-1 border-b border-gray-300 min-h-[32px] flex items-center">
        {typeof value2 === 'string' || typeof value2 === 'number' ? (
          <AppTooltip title={String(value2)} placement="top" showOnlyOnOverflow>
            <span className="block w-full truncate">{value2 ?? '-'}</span>
          </AppTooltip>
        ) : (
          (value2 ?? '-')
        )}
      </div>
    </div>
  );
};
